import React from 'react';
import PropTypes from 'prop-types';

import './MainPage.css';

function Rank({ ranking, pseudo, score, Team }) {
  return (
    <tr>
      <td className="p-light">{ranking}</td>
      <td className="p-light">{pseudo}</td>
      <td className="p-light">{score}</td>
      <td className="p-light">
        <img className="logos-ranking" src={Team.logo} alt={Team.name} />
      </td>
    </tr>
  );
}

export default Rank;

Rank.propTypes = {
  ranking: PropTypes.number.isRequired,
  pseudo: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired
};
